import { GET_DROP_DOWN_LIST_DATA_SUCCESS, GET_DROP_DOWN_LIST_DATA_ERROR } from "./actionTypes";

const INIT_STATE = {
  dropDownData: [],
};

const DropDownListData = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DROP_DOWN_LIST_DATA_SUCCESS:
      return {
        ...state,
        dropDownData: action.payload,
      };

    case GET_DROP_DOWN_LIST_DATA_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default DropDownListData;
